import { gsap, Expo, Linear, Power1 } from 'gsap';

import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
import barba from '@barba/core';
import barbaRouter from '@barba/router';
import barbaPrefetch from '@barba/prefetch';
Swiper.use([Navigation, Pagination, Autoplay]);

import './madg-track/madg-track.js';
import initTeamArchive from './partials/archiveTeam.js';
import initHome from './partials/home.js';
import initPage from './partials/page.js';
import initProjectArchive from './partials/projectArchive.js';
import initProjectSingle from './partials/projectSingle.js';
import './polyfills/nodeListForEach.js';
import './polyfills/objectAssign.js';
import ScrollToPlugin from 'gsap/ScrollToPlugin';
import ScrollTrigger from 'gsap/ScrollTrigger';
import  homeEnterDesktop from './partials/transitions/home.js';
import projectSingleEnterDesktop from './partials/transitions/projectSingle.js';
import teamEnterDesktop from './partials/transitions/archiveTeam.js';
import { projectArchiveEnterDesktop, projectArchiveEnterDesktopBack } from './partials/transitions/projectArchive.js';
import defaultEnterDesktop from './partials/transitions/page.js';
import initGravityForms from './utilities/GravityForms.js';
import SplitText from 'gsap/SplitText';

// See js/madg-track/madg-track.js
new MadgTrack();

Swiper.use([Navigation, Pagination, Autoplay]);

//GSAP Init
gsap.registerPlugin(ScrollToPlugin, ScrollTrigger, SplitText);
// Allow disabling all scroll-based GSAP behavior by setting `window.MADG_DISABLE_SCROLL = true`.
// If enabled, existing ScrollTriggers will be killed and future creations are no-ops.
if (typeof window !== 'undefined' && window.MADG_DISABLE_SCROLL) {
  if (typeof ScrollTrigger !== 'undefined') {
    try {
      ScrollTrigger.getAll && ScrollTrigger.getAll().forEach((t) => t.kill && t.kill());
      // make create/refresh no-ops so other modules don't create new triggers
      ScrollTrigger.create = function () {
        return { kill: function () {}, disable: function () {}, enable: function () {}, refresh: function () {} };
      };
      ScrollTrigger.refresh = function () {};
    } catch (e) {
      console.warn('Error disabling ScrollTrigger', e);
    }
  }
}
gsap.defaults({
  ease: Expo.easeOut,
  duration: 0.65,
});

//Vars
let windowWidthPrev = window.innerWidth;
let isMobile = window.matchMedia('(max-width: 900px)').matches;
let isTouch = window.matchMedia('(pointer:coarse)').matches;
var navOpen,
  navAnimating = false;
var galleryOpen = false;
var gotToPageFromNav = false;
//var menuToggle = document.querySelector('.masthead__nav--toggle');
//var toggleImg = menuToggle.querySelector('img');
//var toggleText = menuToggle.querySelector('span');
var prevImgSrc = null;
var imagesLoaded = false;
var preloadRepeatCounter = 0;
var prefetchedPages = [];
var projectScroll = 0;
var projectCurrentFilter = null;

//Functions
function appHeight() {
  const doc = document.documentElement;
  doc.style.setProperty('--vh', window.innerHeight * 0.01 + 'px');
}

function initNav() {
  var navItemHasChildren = document.querySelectorAll(
    '.nav__list__item__link--hasChildren'
  );
  var allNavItem = document.querySelectorAll('.nav__list__item__link');

  //menuToggle.addEventListener('click', toggleNav);
  navItemHasChildren.forEach((item) => {
    item.addEventListener('click', toggleSubnav);
  });

  function toggleNav() {
    if (navAnimating) return;
    navAnimating = true;
    const subnavArea = document.querySelector('.nav__subitems');
  
    if (navOpen) {
      closeNav(subnavArea);
    } else {
      openNav();
    }
  }
  
  function closeNav(subnavArea) {
    gsap.timeline({
      onStart: () => {
        toggleImg.src = prevImgSrc;
        toggleText.textContent = 'MENU';
        gsap.set('.nav__list__item', {
          pointerEvents: 'none',
        });
      },
      onComplete: () => {
        navOpen = !navOpen;
        navAnimating = !navAnimating;
        resetSubnavs(subnavArea);
      },
    })
    .set('body', { overflowY: 'auto' })
    .to('.nav', {
      css: {
        transform: isMobile ? "translate(0, 150%)" : "translate(100%, 0)",
      },
      duration: 0.5,
      ease: Expo.easeIn,
    });
  }
  
  function openNav() {
    gsap.timeline({
      onStart: () => {
        prevImgSrc = toggleImg.src;
        toggleImg.src = document.querySelector('.masthead__nav--toggle--close').src;
        toggleText.textContent = 'CLOSE';
      },
      onComplete: () => {
        navOpen = !navOpen;
        navAnimating = !navAnimating;
        gsap.set('.nav__list__item', {
          pointerEvents: 'auto',
        });
      },
    })
    .set('body', { overflowY: 'hidden' })
    .set('.nav', {
      css: {
        transform: isMobile ? "translate(0, 100%)" : "translate(100%, 0)",
      },
    })
    .to('.nav', {
      css: { transform: "translate(0,0)" },
    })
    .from('.nav__list__item', {
      yPercent: 50,
      autoAlpha: 0,
      stagger: 0.1,
    }, '<25%')
    .from('.nav__secondary', {
      autoAlpha: 0,
      duration: 0.25,
    }, '<25%');
  }
  
  function resetSubnavs(subnavArea) {
    const openLinks = document.querySelectorAll('.nav__list__item__link--hasChildren[aria-expanded="true"]');
    openLinks.forEach((link) => {
      link.setAttribute('aria-expanded', 'false');
      if (isMobile) {
        gsap.set(link.parentNode.querySelector('nav'), {
          height: 0,
        });
      }
    });
  
    if (subnavArea.firstChild) {
      subnavArea.removeChild(subnavArea.firstChild);
      subnavArea.classList.remove('active');
      gsap.set(subnavArea, { width: 0 });
    }
  }

  function toggleSubnav(e) {
    e.preventDefault();
    e.stopPropagation();
  
    const toggle = e.currentTarget;
    const nav = toggle.parentNode.querySelector('nav');
    const thisSubNavIsOpen = toggle.getAttribute('aria-expanded') === 'true';
    const openLinks = document.querySelectorAll('.nav__list__item__link--hasChildren[aria-expanded="true"]');
    const subnavArea = document.querySelector('.nav__subitems');
  
    if (isMobile) {
      closeOtherMobileSubnavs(openLinks, toggle);
      animateMobileSubnav(toggle, nav, thisSubNavIsOpen);
    } else {
      if (thisSubNavIsOpen) {
        closeDesktopSubnav(toggle, subnavArea);
      } else {
        closeOtherDesktopSubnavs(openLinks, toggle);
        openDesktopSubnav(toggle, nav, subnavArea);
      }
    }
  }
  
  // Close other mobile subnavs
  function closeOtherMobileSubnavs(openLinks, currentToggle) {
    openLinks.forEach((link) => {
      if (link === currentToggle) return;
      gsap.to(link.parentNode.querySelector('nav'), {
        height: 0,
        onStart: () => {
          link.setAttribute('aria-expanded', 'false');
        },
      });
    });
  }
  
  // Animate mobile subnavs
  function animateMobileSubnav(toggle, nav, thisSubNavIsOpen) {
    gsap.to(nav, {
      height: thisSubNavIsOpen ? 0 : 'auto',
      onStart: () => {
        toggle.setAttribute('aria-expanded', thisSubNavIsOpen ? 'false' : 'true');
      },
    });
  }
  
  // Close desktop subnavs
  function closeDesktopSubnav(toggle, subnavArea) {
    gsap.to(subnavArea, {
      width: 0,
      duration: 0.5,
      onStart: () => {
        subnavArea.classList.remove('active');
        toggle.setAttribute('aria-expanded', 'false');
      },
      onComplete: () => {
        subnavArea.removeChild(subnavArea.firstChild);
      },
    });
  }
  
  // Close other desktop subnavs
  function closeOtherDesktopSubnavs(openLinks, currentToggle) {
    openLinks.forEach((link) => {
      link.setAttribute('aria-expanded', 'false');
    });
  }
  
// Open desktop subnav
function openDesktopSubnav(toggle, nav, subnavArea) {
  const navClone = nav.cloneNode(true);
  const linksArr = [...navClone.querySelectorAll('li a')];
  const longestLink = getLongestLink(linksArr);

  subnavArea.innerHTML = '';
  subnavArea.append(navClone);

  const appropriateWidth = calculateAppropriateWidth(longestLink);

  gsap.to(subnavArea, {
    width: appropriateWidth,
    duration: 0.5,
    onStart: () => {
      subnavArea.classList.add('active');
      toggle.setAttribute('aria-expanded', 'true');
    },
  });
}

// Calculate the appropriate width based on the longest link
function calculateAppropriateWidth(longestLink) {
  const linkWidth = longestLink.getBoundingClientRect().width;
  return window.innerWidth * 0.025 + linkWidth;
}
  
  // Get the longest link
  function getLongestLink(linksArr) {
    let linkToLengthObj = {};
  
    linksArr.forEach((link) => {
      let key = link.textContent.length;
      linkToLengthObj[key] = link;
    });
  
    const longestLinkKey = Math.max(...Object.keys(linkToLengthObj));
    return linkToLengthObj[longestLinkKey];
  }
}

function initBorders() {
  function getBorderColor(el) {
    if (el.classList.contains('link--bordered--primaryLight')) return '#fd4732';
    if (el.classList.contains('link--bordered--white')) return 'white';
    return '';
  }

  function createBorder(borderColor, reveal) {
    const border = document.createElement('div');
    border.classList.add('link--bordered--border');

    const positions = ['left', 'bottom', 'top', 'right'];
    positions.forEach((position) => {
      const span = createBorderSpan(borderColor, reveal, position);
      border.appendChild(span);
    });

    return border;
  }

  function createBorderSpan(borderColor, reveal, position) {
    const span = document.createElement('span');
    span.classList.add(`link--bordered--border--${position}`);
    span.style = getSpanStyle(position, borderColor, reveal);
    return span;
  }

  function getSpanStyle(position, borderColor, reveal) {
    const positionStyles = {
      left: `left: 0; bottom: 0; width: 1px; height: ${reveal ? '0%' : '100%'};`,
      bottom: `left: 0; bottom: 0; width: ${reveal ? '0%' : '100%'}; height: 1px;`,
      top: `left: 0; top: 0; width: ${reveal ? '0%' : '100%'}; height: 1px;`,
      right: `right: 0; bottom: 0; width: 1px; height: ${reveal ? '0%' : '100%'};`,
    };

    const style = `position: absolute; ${positionStyles[position]} background: ${borderColor}`;
    return style;
  }

  const borderedElements = document.querySelectorAll('.link--bordered');
  borderedElements.forEach((el) => {
    const borderColor = getBorderColor(el);
    const reveal = el.classList.contains('link--bordered--reveal');
    const border = createBorder(borderColor, reveal);
    el.appendChild(border);
  });
}

function returnBorderAnimation(tl, tgt, pos = "+=0") {
  // Reusable timeline constructor for bordered elements where border draws in

  const isTopOrRight = (target) => {
    return target.classList.contains("link--bordered--border--top") ||
      target.classList.contains("link--bordered--border--right");
  };

  const isBottomOrTop = (target) => {
    return target.classList.contains("link--bordered--border--bottom") ||
      target.classList.contains("link--bordered--border--top");
  };

  const isLeftOrRight = (target) => {
    return target.classList.contains("link--bordered--border--left") ||
      target.classList.contains("link--bordered--border--right");
  };

  const tween = gsap.to(`${tgt} span`, {
    width: function (index, target) {
      if (isBottomOrTop(target)) return "100%";
    },
    height: function (index, target) {
      if (isLeftOrRight(target)) return "100%";
    },
    duration: 0.5,
    stagger: function (index, target) {
      // Return 0 for bottom or left, 0.5 for top or right
      return isTopOrRight(target) ? 0.5 : 0;
    },
  });

  tl.add(tween, pos);
}

function returnBlueprintAnimation(tl, tgt, pos) {
  //Reusable timeline builder for any blueprint draw-ins
  var tween = gsap.fromTo(
    `${tgt} .draw-on-scroll`,
    {
      drawSVG: "0%",
    },
    {
      drawSVG: "100%",
      ease: "none",
    }
  );
  tl.add(tween, pos ? pos : "<");
}

function returnCoordinateAnimation(tl, tgt, pos) {
  //Reusable timeline builder for any coordinate draw-ins
  var tween = gsap
    .timeline()
    .fromTo(
      `${tgt} .coord--line`,
      {
        width: function (index, target) {
          if (target.classList.contains("coord--line--growFromZero")) return 0;
          return "100%";
        },
      },
      {
        width: function (index, target) {
          return `${target.dataset.final}%`;
        },
      }
    )
    .to(
      `${tgt} span span`,
      {
        textContent: function (index, target) {
          return target.dataset.final;
        },
        snap: { textContent: 1 },
      },
      "<"
    )
    .fromTo(
      `${tgt} svg path`,
      {
        drawSVG: "0%",
      },
      {
        drawSVG: "100%",
      },
      "<"
    );

  tl.add(tween, pos ? pos : "+=0");
}

function initGalleryModal() {
  if (!document.querySelector('.gallery')) return;
  var galleryImages = document.querySelectorAll('.gallery-image');
  galleryImages.forEach((img) => {
    img.querySelector('img').dataset.src = getGallerySize(img);
    img.addEventListener('click', openModal);
    var overlay = document.createElement('div');
    overlay.classList.add('gallery-image--overlay');
    var line1 = document.createElement('div');
    line1.classList.add('gallery-image--line--1');
    var line2 = document.createElement('div');
    line2.classList.add('gallery-image--line--2');
    img.append(overlay, line1, line2);
  });
  var currentImage = null;
  var images = [];
  var modalImg = document.querySelector('.gallery--modal img');
  var caption = document.querySelector('.gallery--modal p');

  document
    .querySelector('.gallery--modal--close')
    .addEventListener('click', closeModal);

  document
    .querySelector('.gallery--modal--prev')
    .addEventListener('click', decrementModal);

  document
    .querySelector('.gallery--modal--next')
    .addEventListener('click', incrementModal);

  function openModal(e) {
    var gallery = e.currentTarget.closest('.gallery');
    images = gallery ? gallery.querySelectorAll('.gallery-image') : [e.currentTarget];
    currentImage = Array.prototype.indexOf.call(images, e.currentTarget);
    var image =
      e.currentTarget.tagName === 'IMG'
        ? e.currentTarget
        : e.currentTarget.querySelector('img');
    modalImg.src = image.dataset.src;

    if (image.dataset?.caption) caption.textContent = image.dataset.caption;

    gsap.to('.gallery--modal', {
      autoAlpha: 1,
      onComplete: () => {
        galleryOpen = true;
      },
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeModal();
    });
  }

  function closeModal() {
    gsap.to('.gallery--modal', {
      autoAlpha: 0,
      onComplete: () => {
        var modalImg = document.querySelector('.gallery--modal img');
        modalImg.src = '';
        caption.textContent = '';
      },
    });
  }

  function decrementModal() {
    if (currentImage === 0) {
      currentImage = images.length - 1;
    } else {
      currentImage--;
    }
    var img =
      images[currentImage].tagName === 'IMG'
        ? images[currentImage]
        : images[currentImage].querySelector('img');
    modalImg.src = img.dataset.src;
    caption.textContent = img.dataset?.caption ? img.dataset.caption : '';
  }

  function incrementModal() {
    if (currentImage === images.length - 1) {
      currentImage = 0;
    } else {
      currentImage++;
    }
    var img =
      images[currentImage].tagName === 'IMG'
        ? images[currentImage]
        : images[currentImage].querySelector('img');
    modalImg.src = img.dataset.src;
    caption.textContent = img.dataset?.caption ? img.dataset.caption : '';
  }

  function getGallerySize(img) {
    let src;
    switch (true) {
      case window.innerWidth < 150:
        src = img.querySelector('img').dataset.thumbnail;
        break;
      case window.innerWidth < 300:
        src = img.querySelector('img').dataset.medium;
        break;
      case window.innerWidth < 768:
        src = img.querySelector('img').dataset.medium_large;
        break;
      case window.innerWidth < 1024:
        src = img.querySelector('img').dataset.large;
        break;
      case window.innerWidth < 1536:
        src = img.querySelector('img').dataset['1536x1536'];
        break;
      default:
        src = img.querySelector('img').dataset['2048x2048'];
    }
    let imgLoad = new Image();
    imgLoad.src = src;
    return src;
  }
}

function initMap() {
  if (!document.querySelector('.map')) return;
  const alliant = typeof mapData !== 'undefined' ? 
  { lat: parseFloat(mapData?.lat), lng: parseFloat(mapData?.lng)} :
  { lat: 32.3144168, lng: -90.1024679 };
  const styles = [
    {
      featureType: 'water',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#d3d3d3',
        },
      ],
    },
    {
      featureType: 'transit',
      stylers: [
        {
          color: '#808080',
        },
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry.stroke',
      stylers: [
        {
          visibility: 'on',
        },
        {
          color: '#b3b3b3',
        },
      ],
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#ffffff',
        },
      ],
    },
    {
      featureType: 'road.local',
      elementType: 'geometry.fill',
      stylers: [
        {
          visibility: 'on',
        },
        {
          color: '#ffffff',
        },
        {
          weight: 1.8,
        },
      ],
    },
    {
      featureType: 'road.local',
      elementType: 'geometry.stroke',
      stylers: [
        {
          color: '#d7d7d7',
        },
      ],
    },
    {
      featureType: 'poi',
      elementType: 'geometry.fill',
      stylers: [
        {
          visibility: 'on',
        },
        {
          color: '#ebebeb',
        },
      ],
    },
    {
      featureType: 'administrative',
      elementType: 'geometry',
      stylers: [
        {
          color: '#a7a7a7',
        },
      ],
    },
    {
      featureType: 'road.arterial',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#ffffff',
        },
      ],
    },
    {
      featureType: 'road.arterial',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#ffffff',
        },
      ],
    },
    {
      featureType: 'landscape',
      elementType: 'geometry.fill',
      stylers: [
        {
          visibility: 'on',
        },
        {
          color: '#efefef',
        },
      ],
    },
    {
      featureType: 'road',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#696969',
        },
      ],
    },
    {
      featureType: 'administrative',
      elementType: 'labels.text.fill',
      stylers: [
        {
          visibility: 'on',
        },
        {
          color: '#737373',
        },
      ],
    },
    {
      featureType: 'poi',
      elementType: 'labels.icon',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'poi',
      elementType: 'labels',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'road.arterial',
      elementType: 'geometry.stroke',
      stylers: [
        {
          color: '#d6d6d6',
        },
      ],
    },
    {
      featureType: 'road',
      elementType: 'labels.icon',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {},
    {
      featureType: 'poi',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#dadada',
        },
      ],
    },
  ];
  let map = new google.maps.Map(document.querySelector('.map'), {
    center: alliant,
    zoom: 10,
    styles,
  });

  var icon = {
    path: 'M 25 1 C 16.179688 1 9 8.179688 9 17 C 9 31.113281 23.628906 47.945313 24.25 48.65625 C 24.441406 48.875 24.710938 49 25 49 C 25.308594 48.980469 25.558594 48.875 25.75 48.65625 C 26.371094 47.933594 41 30.8125 41 17 C 41 8.179688 33.820313 1 25 1 Z M 25 12 C 28.3125 12 31 14.6875 31 18 C 31 21.3125 28.3125 24 25 24 C 21.6875 24 19 21.3125 19 18 C 19 14.6875 21.6875 12 25 12 Z',
    fillColor: '#d62313',
    fillOpacity: 1,
    strokeWeight: 0,
    anchor: new google.maps.Point(25, 50),
  };

  let marker = new google.maps.Marker({
    position: alliant,
    map,
    icon,
  });
}

async function killAllScrollTrigger() {
  var st = ScrollTrigger.getAll();
  await Promise.all(
    st.map(async (trigger) => {
      await trigger.kill();
      trigger = null;
    })
  );
}

function initLinkListeners(container) {
  //Enhances barba prefetch by preloading page images/videos when hovering the link to that page
  async function loadLinkImagesOnHover(link) {
    var href = link.currentTarget.href;
    if (prefetchedPages.includes(href) || href.includes('/contact')) return;
    barba.cache.getRequest(href).then((res) => {
      prefetchedPages.push(href);
      var newPage =
        document.implementation.createHTMLDocument().documentElement;
      newPage.innerHTML = res;

      var images = newPage.querySelectorAll("img[data-preload='true'");
      Array.from(images).forEach((img) => {
        if (img.src) loadImage(img);
      });

      var bgSections = newPage.querySelectorAll('[data-preload-bg="true"');
      Array.from(bgSections).forEach((section) => {
        loadBgImage(section);
      });
    }).catch(e => console.log(e))
  }
  Array.from(container.querySelectorAll("a")).forEach((link) =>
    link.addEventListener("mouseover", loadLinkImagesOnHover)
  );
}

//Supporting functions for preloading on link hovers
const loadImage = (img) =>
  new Promise((resolve, reject) => {
    const image = new Image();

    image.onload = (e) => {
      resolve(image);
    };

    image.onerror = (e) => {
      reject(img.src);
    };

    // image.width = 500
    image.src = img.src;
  });

const loadBgImage = (section) =>
  new Promise((resolve, reject) => {
    var img = section.style.backgroundImage.slice(4, -1).replace(/"/g, '');
    const image = new Image();

    image.onload = (e) => {
      resolve(image);
    };

    image.onerror = (e) => {
      reject(img);
    };

    // image.width = 500
    image.src = img;
  });

const loadImages = (data) =>
  new Promise((resolve, reject) => {
    var container = data.next?.container ? data.next.container : document;
    var images = container.querySelectorAll('img[data-preload="true"]');
    var bgImages = container.querySelectorAll('[data-preload-bg="true"]');
    Promise.all([
      Promise.all(
        Array.from(images)
          .filter((img) => img.src !== '')
          .map(loadImage)
      ),
      Promise.all(Array.from(bgImages).map(loadBgImage)),
    ]).then(() => {
      imagesLoaded = true;
      resolve('success');
    });
  });

const playPreloader = (data) =>
  new Promise((resolve, reject) => {
    var loadingText = new SplitText('.preloader h3', {
      type: ['chars'],
    });
    var svgElements = gsap.utils
      .toArray(
        '.preloader--header path, .preloader--header line, .preloader--header polyline'
      )
      .sort(() => {
        return 0.5 - Math.random();
      });
    return gsap
      .timeline({
        repeat: -1,
        repeatDelay: 0.25,
        defaults: {
          duration: 0.75,
          ease: Power1.easeOut,
        },
        onRepeat: function () {
          preloadRepeatCounter++;
          if (preloadRepeatCounter >= 1 && imagesLoaded) {
            this.pause();
            gsap
              .timeline()
              .to('.preloader', {
                autoAlpha: 0,
                duration: 0.25,
                onComplete: () => {
                  resolve();
                },
              })
              .set(
                '.masthead__nav--toggle, .masthead__title, .masthead__logo',
                {
                  pointerEvents: 'all',
                }
              );
          }
        },
      })
      .set('.preloader', {
        autoAlpha: 1,
      })
      .set('.masthead__nav--toggle, .masthead__title, .masthead__logo', {
        pointerEvents: 'none',
      })
      .fromTo(
        svgElements,
        {
          drawSVG: '0%',
        },
        {
          drawSVG: '100%',
          ease: 'none',
          stagger: 0.1,
        }
      )
      .fromTo(
        '.preloader--coord--line',
        {
          width: '0',
        },
        {
          width: '100%',
          stagger: 0.2,
        },
        '<'
      )
      .fromTo(
        '.preloader--coord span span',
        {
          textContent: 0,
        },
        {
          textContent: (index, target) => {
            if (index === 0) return 111;
            if (index === 1) return 725;
            if (index === 2) return 325;
          },
          snap: { textContent: 1 },
          stagger: 0.2,
        },
        '<'
      )
      .fromTo(
        '.preloader--coord--1 svg path',
        {
          drawSVG: '0%',
        },
        {
          drawSVG: '100%',
          ease: 'none',
        },
        '<'
      )
      .set('.preloader--coord--line', {
        alignSelf: 'flex-end',
      })
      .fromTo(
        svgElements,
        {
          drawSVG: '100%',
        },
        {
          drawSVG: '0%',
          ease: 'none',
          delay: 0.5,
        }
      )
      .to(
        '.preloader--coord--line',
        {
          width: '0%',
          stagger: 0.2,
        },
        '<'
      )
      .to(
        '.preloader--coord span span',
        {
          textContent: 0,
          snap: { textContent: 1 },
          stagger: 0.2,
        },
        '<'
      )
      .fromTo(
        '.preloader--coord--1 svg path',
        {
          drawSVG: '100%',
        },
        {
          drawSVG: '0%',
          ease: 'none',
        },
        '<'
      );
  });



//Barba Stuff
const barbaRoutes = [
  {
    path: '/',
    name: 'home',
  },
  {
    path: '/project/:name',
    name: 'project-single',
  },
  {
    path: '/projects',
    name: 'project-archive',
  },
  {
    path: '/team',
    name: 'team',
  },
];
barba.use(barbaRouter, {
  routes: barbaRoutes,
});
barba.use(barbaPrefetch); //Set up to preload content when link enters viewport

barba.hooks.beforeLeave((data) => {
  if (navOpen || galleryOpen) {
    var wipeWrapper = document.createElement('div');
    wipeWrapper.classList.add('wipe-wrapper');
    document.querySelector('.wrapper').append(wipeWrapper);
  }
});

barba.hooks.leave(async (data) => {
  if (data.trigger && data.trigger === 'back' && gotToPageFromNav) {
    var scopedToggleImg = document.querySelector('.masthead__nav--toggle img');
    var scopedToggleText = document.querySelector('.masthead__nav--toggle span');
    prevImgSrc = scopedToggleImg.src;
    scopedToggleImg.src = document.querySelector(
              '.masthead__nav--toggle--close'
            ).src;
    scopedToggleText.textContent = 'CLOSE';
    navOpen = true;
    killAllScrollTrigger();
    gsap.timeline()
    .set('.nav', {
      css: {
        transform: 'translate(0,0)'
      }
    })
    .set('body', {
      overflowY: 'hidden'
    })
    .set(data.current.container, {
      autoAlpha: 0
    })
    .set(window, {
      scrollTo: 0
    })
    return;
  } else if (navOpen) {
    gotToPageFromNav = true;
    return gsap
      .timeline()
      .to('.wipe-wrapper', {
        width: isMobile ? '100%' : 'calc(100% - 105px)',
        duration: 0.5,
      })
      .set(window, {
        scrollTo: 0,
        onComplete: killAllScrollTrigger,
      })
      .set('body', {
        overflowY: 'auto'
      })
      .set('.nav', {
        onComplete: () => {
          toggleImg.src = prevImgSrc;
          toggleText.textContent = 'MENU';
          navOpen = false;
          navAnimating = false;

          var openLinks = document.querySelectorAll(
            '.nav__list__item__link--hasChildren[aria-expanded="true"]'
          );
          openLinks.forEach((link) => {
            link.setAttribute('aria-expanded', 'false');
            if (isMobile) {
              gsap.set(link.parentNode.querySelector('nav'), {
                height: 0,
              });
            }
          });
          var subnavArea = document.querySelector('.nav__subitems');
          if (subnavArea.firstChild) {
            subnavArea.removeChild(subnavArea.firstChild);
            subnavArea.classList.remove('active');
            gsap.set(subnavArea, {
              width: 0,
            });
          }
        },
        yPercent: isMobile ? 100 : 0,
        xPercent: isMobile ? 0 : 100,
      })
      .set(data.current.container, {
        autoAlpha: 0,
      });
  } else if (galleryOpen) {
    gotToPageFromNav = false;
    return gsap
      .timeline()
      .to('.wipe-wrapper', {
        width: isMobile ? '100%' : 'calc(100% - 105px)',
        duration: 0.5,
      })
      .set(window, {
        scrollTo: 0,
        onComplete: killAllScrollTrigger,
      })
      .set('.gallery--modal', {
        onComplete: () => {
          galleryOpen = false;
        },
        autoAlpha: 0,
      })
      .set(data.current.container, {
        autoAlpha: 0,
      });
  } else {
    gotToPageFromNav = false;
    return gsap
      .timeline()
      .to(data.current.container, {
        autoAlpha: 0,
      })
      .set(window, {
        scrollTo: 0,
        onComplete: killAllScrollTrigger,
      });
  }
});

barba.hooks.afterLeave((data) => {
  //response had no data-barba="container" (redirect, error page, etc.); avoid the addContainer crash and hard-reload instead
  if (!data.next.container) {
    data.next.container = document.createElement('div');
    window.location.href = data.next.url.href;
  }
});

barba.hooks.beforeEnter((data) => {
  return new Promise((resolve) => {
    initBorders();
    initGalleryModal();
    initGravityForms();
    initMap();
    //Make sure we have all the stuff preloaded before enter animation plays
    loadImages(data).then(() => {
      resolve('success');
    });
  });
});

barba.hooks.after((data) => {
  var wipeWrapper = document.querySelector('.wipe-wrapper');
  if (wipeWrapper) wipeWrapper.parentNode.removeChild(wipeWrapper);
});

barba.init({
  debug: true,
  timeout: 5000, //default 2000ms is too short for slower project pages and causes spurious prefetch/click timeouts
  prevent: function ({ el, event, href }) {
    //custom script on contact page can't be reloaded for Barba by us.
    if (href.indexOf('/contact') !== -1) return true;
    //never intercept links to downloadable files; their response has no barba container and crashes addContainer
    if (/\.(pdf|docx?|xlsx?|pptx?|zip|rar|jpe?g|png|gif|svg|mp4|mov)($|\?)/i.test(href)) return true;
    return false;
  },
  transitions: [
    {
      beforeOnce(data) {
        return new Promise((resolve) => {
          initLinkListeners(document);
          gsap.to(window, {
            scrollTo: 0,
            duration: 0.5,
          });
          if (data.next.container.querySelector('.project-archive'))
            initProjectArchive(isMobile, isTouch);
          playPreloader(data).then(() => {
            resolve()
          });
        });
      },
      once(data) {
        if (data.next.container.querySelector('.home-page')) {
          homeEnterDesktop(data, isMobile, isTouch);
        } else if (data.next.container.querySelector('.project-archive')) {
          projectArchiveEnterDesktop(data, isMobile, isTouch);
        } else if (data.next.container.querySelector('.project-single')) {
          projectSingleEnterDesktop(data, isMobile, isTouch);
        } else if (data.next.container.querySelector('.team-archive')) {
          teamEnterDesktop(data, isMobile, isTouch);
        }  else if (data.next.container.querySelector('.page-404')){
          return gsap.timeline()
        .set('.wipe-wrapper', {
        autoAlpha: 0
        })
        .set(data.next.container, {
        autoAlpha: 1
        })
        .to('.hide-on-load', {
        autoAlpha: 1, 
        duration: 0.5
        })
        } else {
          defaultEnterDesktop(data, isMobile, isTouch);
        }
      },
      afterOnce(data) {
        initNav();
        if (data.next.container.querySelector('.home-page'))
          initHome(isMobile, isTouch, true);
        if (data.next.container.querySelector('.project-single'))
          initProjectSingle(isMobile, isTouch);
        if (data.next.container.querySelector('.team-archive'))
          initTeamArchive(isMobile, isTouch);
      },
    },
    {
      name: 'homeEnter',
      to: {
        route: ['home'],
      },
      enter(data) {
        homeEnterDesktop(data, isMobile, isTouch);
      },
      after(data) {
        initHome(isMobile, isTouch, true);
      },
    },
    {
      name: 'projectSingleEnter',
      to: {
        route: ['project-single'],
      },
      beforeLeave(data) {
        if(data.current.route.name === 'project-archive') setProjectArchiveScrollPos();
      }, 
      enter(data) {
        projectSingleEnterDesktop(data, isMobile, isTouch);
      },
      after(data) {
        initProjectSingle(isMobile, isTouch);
      },
    },
    {
      name: 'projectArchiveEnter',
      to: {
        route: ['project-archive'],
      }, 
      beforeLeave(data) {
        if(data.current.route.name === 'project-single' && projectScroll) {
          gsap.set(data.current.container, {
            autoAlpha: 0
          })
        }
      }, 
      beforeEnter(data) {
        initProjectArchive(isMobile, isTouch);
      },
      enter(data) {
        if(data.current.route.name === 'project-single' && projectScroll) {
          projectArchiveEnterDesktopBack(data, projectScroll) 
        } else {
          projectArchiveEnterDesktop(data, isMobile, isTouch);
        }
      },
    },
    {
      name: 'teamEnter',
      to: {
        route: ['team'],
      },
      enter(data) {
        teamEnterDesktop(data, isMobile, isTouch);
      },
      after(data) {
        initTeamArchive(isMobile, isTouch);
      },
    },
    {
      name: 'default',
      enter(data) {
        if(data.next.container.classList.contains('error-404')){
          return gsap.timeline()
        .set('.wipe-wrapper', {
        autoAlpha: 0
        })
        .set(data.next.container, {
        autoAlpha: 1
        })
        .to('.hide-on-load', {
        autoAlpha: 1, 
        duration: 0.5
        })
        } else {
        defaultEnterDesktop(data, isMobile, isTouch);
        }
      },
    },
  ],
});

window.addEventListener('resize', () => {
  appHeight();
  if(window.innerWidth >= 900 & !(navAnimating || navOpen)) {
    document.querySelector('nav').style.transform = `translate(${window.innerWidth - 105}px)`
  }
  if (
    (windowWidthPrev < 900 && window.innerWidth >= 900) ||
    (windowWidthPrev > 900 && window.innerWidth <= 900)
  ) {
    window.location.reload();
  }
  windowWidthPrev = window.innerWidth;
});
appHeight();

function setProjectArchiveScrollPos() {
  projectScroll = window.scrollY;
}

function setProjectCurrentFilter() {
  projectCurrentFilter = document.querySelector('.project-archive__header').dataset.filterApplied;
}

export {
  returnBorderAnimation,
  returnBlueprintAnimation,
  returnCoordinateAnimation, 
  setProjectArchiveScrollPos,
  setProjectCurrentFilter
};

